export const FETCH_CHANNEL_API = '/channel/:id';
